import { SocialPlatformId } from '@app/modules/social-export/domain/platforms';
import { useFormContext } from 'react-hook-form-mui';

export interface CreateFragmentFormValues {
  stationId: string;
  title: string;
  description: string;
  tags: string;
  doExternalExport: boolean;
  platformUpload: Record<SocialPlatformId, { enabled: boolean; config: unknown }>;
}

export function useFragmentForm() {
  return useFormContext<CreateFragmentFormValues>();
}
